import { useState } from "react";
import { Link } from "react-router-dom";
import { Field } from "formik";
import FormBody, { InputError } from "../../components/form/FormBody";
import instance from "../../utils/api_instance.util";
import { loginValidation } from "../../utils/validation.util";

const ForgotPassword = () => {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const onSubmit = async (values) => {
    if (sending) return;
    setSending(true);
    try {
      const { data } = await instance.post("/api/v1/admin/auth/forgot-password", {
        email: String(values.email || "").trim().toLowerCase(),
      });
      setMessage(data?.message || "If an account exists for this email, reset instructions have been sent.");
    } catch (err) {
      setMessage(err.response?.data?.message || "We can't reach the server. Check your connection and try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="card mb-3">
                  <div className="card-body">
                    <h5 className="card-title text-center pb-0 fs-4">Forgot Password</h5>
                    <p className="text-center small">Enter the email for your admin account.</p>
                    <FormBody
                      initialValues={{ email: "" }}
                      validationSchema={loginValidation.pick(["email"])}
                      onSubmit={onSubmit}
                    >
                      <div className="col-12 mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <Field type="email" className="form-control" id="email" name="email" autoComplete="username" />
                        <InputError name="email" />
                      </div>
                      <button className="btn btn-primary w-100" type="submit" disabled={sending}>
                        {sending ? "Sending..." : "Send reset link"}
                      </button>
                    </FormBody>
                    {message ? <p className="small mt-3 mb-0">{message}</p> : null}
                    <div className="text-center mt-3">
                      <Link to="/login">Back to sign in</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ForgotPassword;
